




















































































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class HistoryInfoLayer extends Vue {
  @Prop() private data?: any;
  private type = 'search'; // search, certification, excel, admin, add
  private searchKeyword = '';
  private identifiers = '';

  private get viewTitle() {
    if ((this.$parent.$refs.contentTop as any).focusTableTabName === 'customTab') {
      return this.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_CUSTOM_TAB');
    } else {
      return this.$t('ACCESSHISTORIES_PRIVACY_ACCESS_HISTORIES_ADMIN_TAB');
    }
  }

  private get menuUri() {
    return !!this.data.menuUri ? `${window.location.origin}${this.data.menuUri}` : '';
  }

  private closePop() {
    this.$emit('update:showFlg', false);
  }

  private viewDetail() {
    if (this.data.workingDetail.searchKeyword) {
      this.searchKeyword = '(' + this.data.workingDetail.searchKeyword + ')';
    }
    if(this.data.workingDetail.identifiers.length > 0) {
      this.identifiers = '{' + this.data.workingDetail.identifiers.join('},{') + '}';
    }
  }

  private typeDetail() {
    switch (this.data.workingType) {
      case 'SEARCH':
        this.type = 'search';
        break;

      case 'CHANGE':
      case 'DELETE':
        this.type = 'admin';
        break;

      case 'ADD':
        this.type = 'add';
        break;

      case 'DOWNLOAD':
      case 'UPLOAD':
      case 'CREATE':
        this.type = 'excel';
        break;

      case 'CERTIFICATION':
        this.type = 'certification';
        break;

      case 'BLOCK':
        this.type ='block';
        break;
    }
  }
  mounted() {
    this.typeDetail();
    this.viewDetail();
  }
}
